import { Injectable, InjectionToken } from '@angular/core';
import { Moment } from 'moment';
import { IUserInfo } from '@nimbus-library/features/menu/models/i-user.info';

export const TOKEN_STORAGE = new InjectionToken<string>('authentication.tokenStorageName');
export const USER_INFO_STORAGE = new InjectionToken<string>('authentication.userInfoStorageName');

@Injectable()
export abstract class IAuthenticationStorage {
  public abstract saveAuthData(token: string, user: IUserInfo, expirationDate: Moment): void;
  public abstract clearAuthData(): void;
  public abstract getUserInfo(): IUserInfo;
  public abstract saveTeamsInfo(username: string, expirationDate: Moment): void;
  public abstract getTeamsInfo(): string;
}
